let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("852TS")).then(() => parcelRequire('ei39Q'));